export default __webpack_public_path__ + "static/media/KBM04376.2d4ac79e.webp";